import { Row, Col, PageWrapper } from '@qonsoll/react-design'
import { HeaderBreadcrumbs, Spinner } from 'components'
import {
  useGetNewspaperInitialValues,
  useNewspaperBaseActions
} from 'domains/Newspaper/hooks'

import { NewspaperAdvancedSettingForm } from 'domains/Newspaper/components'
import { useParams } from 'react-router-dom'
import { useTranslations } from 'contexts/Translation'

const NewspaperAdvancedSettingEdit = (props) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting params from router */
  const { newspaperId } = useParams()

  /* Fetching newspaper initial values */
  const [initialValues, loading] = useGetNewspaperInitialValues(newspaperId)
  /* Getting base actions */
  const { onBack } = useNewspaperBaseActions()

  /* Configuring page header */
  const headingProps = {
    title: t('Newspaper advanced settings'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  return (
    <PageWrapper
      onBack={onBack}
      breadcrumbs={<HeaderBreadcrumbs />}
      headingProps={headingProps}>
      <Row noGutters>
        {loading ? (
          <Col>
            <Spinner
              height="70vh"
              text={t('Newspaper advanced setting loading')}
            />
          </Col>
        ) : (
          <Col cw={[12, 12, 10, 8, 7]}>
            <NewspaperAdvancedSettingForm initialData={initialValues} />
          </Col>
        )}
      </Row>
    </PageWrapper>
  )
}

export default NewspaperAdvancedSettingEdit
